import { Link } from 'react-router-dom';

import type { CategoryCardModel } from '@/features/catalog/api';

export function CategoryCard({ category, count }: { category: CategoryCardModel; count?: number }) {
  return (
    <article className={`category-card category-card--${category.slug}`}>
      <Link to={category.route}>
        <div className="category-card__visual" aria-hidden="true">
          <i className={category.icon} />
        </div>
        <div className="category-card__content">
          <span>{count === undefined ? 'Personalized collection' : `${count} products`}</span>
          <h3>{category.shortTitle}</h3>
          <p>{category.description}</p>
          <strong>
            Explore category <i className="pi pi-arrow-right" aria-hidden="true" />
          </strong>
        </div>
      </Link>
    </article>
  );
}
